// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__kjZvc","titleWrap":"styles_titleWrap__qPqV_","title":"styles_title__8NLkX","info":"styles_info__6hkJp","redirectWrap":"styles_redirectWrap__m_vyP"};
module.exports.__checksum = "86ba87d763c2"